import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import { addToCart } from './actions';
import Swal from 'sweetalert2';
class CustomSubServices extends Component {

  selectedService = null

  constructor(props) {
    super(props)
    this.state = {
      selectedService: null
    }
  }

  setPriceToZero = (service) => {
    service.originalPrice = service.price;
    service.price = 0;
    service.ivaPrice = 0;
    return service
  }

  addToCart = () => {
    if (this.state.selectedService) {
      if (_.some(this.props.shoppingCart.items, e => e.serviceId === this.state.selectedService.serviceId)) {
        Swal.fire({
          text: 'Parece que ya ha añadido ese servicio',
          confirmButtonClass: 'jump button-primary'
        });
      } else if (_.some(this.props.shoppingCart.items, item => item.parent === this.state.selectedService.parent)) {
        Swal.fire({
          text: 'Parece que ya ha añadido un servicio de este mismo tipo',
          confirmButtonClass: 'jump button-primary'
        });
      } else if (_.some(this.props.shoppingCart.items, item => item.parent !== this.state.selectedService.parent &&
        _.some(this.props.services, service => service.serviceId === item.parent))) {
        Swal.fire({
          text: 'Parece que ya ha añadido un servicio de otro tipo de Mantenimiento Oficial',
          confirmButtonClass: 'jump button-primary'
        });
      } else {
        if (this.state.selectedService.whoPays) {
          Swal.fire({
            html:
              '<p id="gratis-titulo">Mazda te ofrece esta revisión de forma gratuita</p>' +
              '<p id="gratis-texto"><i>Este mensaje va destinado a los adquirentes de vehículos con financiación con mantenimiento gratuito incluido en su contrato de financiación y en las condiciones contratadas. Revisa tu contrato para verificar que tienes derecho al mantenimiento gratuito o confírmalo con tu concesionario. Lamentamos las molestias que podamos ocasionar, si recibes este mensaje por error.</i></p>',
            confirmButtonText: 'Aceptar',
            customClass: {
              confirmButton: 'jump',
              content: 'mazda-modal-content',
            }
          })
        }
        if (this.state.selectedService.name.includes('Revisión')) {
          this.state.selectedService.name = this.state.selectedService.name + ' de Mto. Oficial'
        }
        else {
          this.state.selectedService.name = 'Mto. Oficial de ' + this.state.selectedService.name
        }
        this.props.addToCart(this.state.selectedService, this.props.currentMake, this.props.carData);
      }
    }
  }

  setSelectedService = (service) => {
    if (service) {
      if (service.whoPays) {
        service = this.setPriceToZero(service)
      }
      this.setState({
        selectedService: service
      })
    }
  }

  changeSelectedService = (event) => {
    let currentDOMSelectID = (event.target).getAttribute('id')
    let DOMcustomServiceBox = document.querySelectorAll('[id^="customSubService"]');
    _.forEach(DOMcustomServiceBox, DOM => {
      let selectDOM = DOM.lastChild
      let idAttribute = selectDOM.getAttribute('id')
      if (idAttribute != currentDOMSelectID) {
        DOM.getElementsByTagName('option')[0].selected = 'selected'
      }
    })
    if (event.target.value) {
      this.setSelectedService(JSON.parse(event.target.value))
    }
  }

  showFlexibleInfo = () => {
    let description = document.getElementById('customServiceDescription')
    if (description) {
      description.classList.remove('hide')
      description.classList.add('visible')
    }
    let info = document.getElementById('customServiceInfo')
    if (info) {
      info.classList.remove('visible')
      info.classList.add('hide')
    }
  }

  hideFlexibleInfo = () => {
    let description = document.getElementById('customServiceDescription')
    if (description) {
      description.classList.remove('visible')
      description.classList.add('hide')
    }
    let info = document.getElementById('customServiceInfo')
    if (info) {
      info.classList.remove('hide')
      info.classList.add('visible')
    }
  }


  render() {
    const allServices = this.props.services;
    let customServices = []
    let hasSubServices = null
    let flexible = null
    let subServices = null
    let renderServicesTemplate = null

    const renderCustomServiceOptions = (services) => {
      let orderedServices = services.sort((a, b) => a.order - b.order)
      orderedServices = orderedServices.map((subService, i) =>
        !subService.useSecondPriceFor ? <option key={subService.serviceId} value={JSON.stringify(subService)}>{subService.name}</option> : ''
      )
      return orderedServices
    }

    allServices.forEach(service => {
      if (service.children) {
        hasSubServices = true
        subServices = service.children
        customServices.push(service)
      }
      if (service.flexible) {
        flexible = true
      }
    });
    if (hasSubServices && !flexible) {
      renderServicesTemplate = customServices.map((service, index) => {
        return (
          <div id={"customSubService" + service.serviceId} className="customSubService">
            <div className="customSubService__title">
              {service.name}
            </div>
            <img src={"/images/" + service.name + '.png'} width="60" style={{ marginRight: "15px" }} />
            <select id={'serviceSelect' + customServices[index].serviceId} onChange={this.changeSelectedService} className="customSubService__select">
              <option value="" selected disabled hidden>---</option>
              {service.children && renderCustomServiceOptions(service.children)}
            </select>
          </div>
        )
      })
    }
    return (
      <div className="customSubServiceForm">
        <div className="customSubServiceBox">
          {!flexible && hasSubServices
            ? <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
              {renderServicesTemplate}
            </div>
            : null}
          {flexible && hasSubServices
            ? <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <div className="customSubService">
                <div className="customSubService__title">
                  Mantenimiento Flexible
                                </div>
                <img src={"/images/ico_flexible.png"} width="60" style={{ marginRight: "15px" }} />
                <select id={'serviceSelect' + customServices[0].serviceId} onChange={this.changeSelectedService} className="customSubService__select">
                  <option value="" selected disabled hidden>---</option>
                  <option value="" selected disabled hidden>---</option>
                  {subServices && renderCustomServiceOptions(subServices)}
                </select>
              </div>
              <div id="customServiceInfo" className="customSubService__flexibleInfo">
                <span className="info">* Si quieres más inforamción sobre el Mantenimiento Flexible (My Mazda Service),</span>
                <span onClick={this.showFlexibleInfo} className="customSubService__flexibleInfo__link">Haz click aquí</span>
              </div>
              <div id="customServiceDescription" className="customSubService__description hide">
                Los vehículos con tipo de manteniendo flexible, indican mediante el testigo de la Llave de Revisiones, el momento en que se debe pasar la próxima Revisión de Mantenimiento, y que dependerá del modo de conducción y siempre con un máximo de 20.000 km o 1 año, lo que antes ocurra.
                            <span onClick={this.hideFlexibleInfo} className="close-button"></span>
              </div>
            </div>
            :
            null
          }
        </div>
        <div className="customSubServiceForm__button">
          {
            this.state.selectedService
              ? <button
                onClick={this.addToCart}
                className="jump pull-right blue-button-active">
                <span className="labelFlip1">AÑADIR</span>
                <span className="labelFlip2" style={{ position: 'absolute', visibility: 'hidden' }}>AÑADIR</span>
              </button>
              : null
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    services: state.catalogue.services,
    currentMake: state.make.currentMake,
    shoppingCart: state.checkout.shoppingCart,
    carData: state.checkout.carData.carDataData
  };
};

const bindActions = dispatch => ({
  addToCart: (element, makeObject, car) => dispatch(addToCart(element, makeObject, car))
});

export default connect(mapStateToProps, bindActions)(CustomSubServices);


// WEBPACK FOOTER //
// ./src/workflow/checkout/services/customSubService.js